import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SfSelectOption } from 'ngx-smart-form';
import { catchError, filter, map, Observable, of } from 'rxjs';
import { Channel } from 'src/app/settings/canals/channel';
import { environment } from 'src/environments/environment';
import { Certificate } from 'src/interfaces/certificate';
import { BeChannel } from '../../settings/canals/be-channel';
import { ChannelFactory } from '../../settings/canals/channel-factory';
import { ChannelStatus } from '../../settings/canals/channel-status';
import { genHttpParams } from '../../_utils/utils';

@Injectable({
  providedIn: 'root',
})
export class ChannelService {
  private readonly endpointQuery = `${environment.api}/canale-query/canale`;
  private readonly endpointCommand = `${environment.api}/canale-command/canale`;

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<Channel[]>(this.endpointQuery);
  }

  search(
    page: number,
    size: number,
    channelFilter?: Partial<Channel>
  ): Observable<{ total: number; items: Channel[] }> {
    let params = genHttpParams(channelFilter);
    params = params.set('page', page).set('size', size);
    if (channelFilter?.piva) {
      params = params.set('PIva', channelFilter.piva);
    }
    return this.http
      .get<{ canali: BeChannel[]; total: number }>(
        this.endpointQuery + '/search',
        {
          params: params,
        }
      )
      .pipe(
        map((res) => ({
          items: res.canali.map((c) => ChannelFactory.toView(c)),
          total: res.total,
        })),
        catchError((err) => of({ items: [], total: 0 }))
      );
  }

  add(formData: Partial<Channel>) {
    let body: Partial<Channel> = {
      ...formData,
      status: ChannelStatus.ACTIVE,
    };
    return this.http.post<{ id: string }>(this.endpointCommand, body);
  }

  edit(
    updatedCanal: Partial<Channel & { certificato: Partial<Certificate> }>,
    id: string
  ) {
    let body: Partial<Channel> = {
      ...updatedCanal,
    };
    return this.http.patch(this.endpointCommand + '/' + id, body);
  }

  delete(id: string) {
    return this.http.delete(this.endpointCommand + '/' + id);
  }

  getByID(id: string) {
    return this.http
      .get<BeChannel>(this.endpointQuery + '/' + id)
      .pipe(map((res) => ChannelFactory.toView(res)));
  }

  getOptions(filter: Partial<Channel>): Observable<SfSelectOption[]> {
    return this.search(1, 1000, filter).pipe(
      map((res) => res.items.map((c) => ({ view: c.nome, value: c.id })))
    );
  }
}
